import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function EditIcon(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M6.66657 17.6H3.46657C3.18367 17.6 2.91236 17.4876 2.71232 17.2876C2.51228 17.0875 2.3999 16.8162 2.3999 16.5333V2.66667C2.3999 2.38378 2.51228 2.11246 2.71232 1.91243C2.91236 1.71239 3.18367 1.60001 3.46657 1.60001H13.0666C13.3495 1.60001 13.6208 1.71239 13.8208 1.91243C14.0209 2.11246 14.1332 2.38378 14.1332 2.66667V6.93334"
          stroke={AppTheme.DEFAULT_COLOR}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.5332 17.0667L9.86658 17.6L10.3999 14.9333L15.1999 10.1333L17.3332 12.2667L12.5332 17.0667Z"
          stroke={AppTheme.DEFAULT_COLOR}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </TouchableOpacity>
  );
}
